module.exports = __webpack_public_path__ + "img/A7404562.31049197.jpg";